export class WizardOptions {
  selectedDocument: string = '';
  usingStrang: boolean = false;
}
